var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPermission(_vm.permission))?_c('tooltip',{attrs:{"label":_vm.tooltip,"type":"small","placement":"top"}},[_c('router-link',{staticClass:"button is-primary",attrs:{"to":_vm.to,"tag":"button"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-plus"})])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }